<section class="login min-h-screen w-full flex items-center justify-center px-4 py-10" dir="rtl">
  <main class="w-full max-w-md">
    <div class="card-2026 card-2026--elevated">

      <!-- Brand / heading -->
      <div class="flex flex-col items-center text-center gap-3 pb-6 border-b border-ink-100">
        <span
          class="flex items-center justify-center w-16 h-16 rounded-2xl bg-accent-100 text-accent-600"
          aria-hidden="true"
        >
          <i class="material-icons text-4xl">verified_user</i>
        </span>
        <h1 class="text-2xl md:text-3xl font-bold text-primary-700">
          {{ headerText }}
        </h1>
        <p class="text-base text-ink-500">{{ subHeaderTxt }}</p>
      </div>

      <!-- Form -->
      <form (ngSubmit)="onSubmit()" novalidate class="pt-6 flex flex-col gap-5">

        <!-- Email -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="loginEmail">
            {{ emailLabel }}
          </label>
          <input
            id="loginEmail"
            type="email"
            inputmode="email"
            autocomplete="username"
            class="input-2026"
            [(ngModel)]="userEmail"
            name="email"
            [attr.aria-invalid]="errorMessages['email'] ? 'true' : null"
            [attr.aria-describedby]="errorMessages['email'] ? 'loginEmailError' : null"
          />
          <small
            id="loginEmailError"
            class="form-row-2026__error"
            role="alert"
            *ngIf="errorMessages['email']"
          >
            {{ errorMessages["email"] }}
          </small>
        </div>

        <!-- Password -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="loginPassword">
            {{ passLabel }}
          </label>
          <input
            id="loginPassword"
            type="password"
            autocomplete="current-password"
            class="input-2026"
            [(ngModel)]="userPassword"
            name="password"
            [attr.aria-invalid]="errorMessages['password'] ? 'true' : null"
            [attr.aria-describedby]="errorMessages['password'] ? 'loginPasswordError' : null"
          />
          <small
            id="loginPasswordError"
            class="form-row-2026__error"
            role="alert"
            *ngIf="errorMessages['password']"
          >
            {{ errorMessages["password"] }}
          </small>
        </div>

        <!-- Submit -->
        <div class="pt-4">
          <button
            type="submit"
            class="btn-2026--primary w-full"
            [disabled]="loading"
          >
            <span *ngIf="!loading">{{ btnText }}</span>
            <span *ngIf="loading" class="flex items-center gap-2">
              <mat-spinner diameter="22"></mat-spinner>
              <span class="text-base">מתחבר...</span>
            </span>
          </button>
        </div>

      </form>
    </div>

    <p class="text-center text-sm text-ink-500 mt-6">
      בית הכנסת תפארת ישראל, גני צבי
    </p>
  </main>
</section>
